/* eslint-disable react/display-name */
import React, { useEffect, useState } from "react";
import { Col, Row, Card } from "antd";
import Auxiliary from "util/Auxiliary";
import { useDispatch, useSelector } from "react-redux";
import { getClassAssignmentSession } from "../../appRedux/actions/Dashboard";
import { getFormattedFromStamp } from "../../util/DateUtil";
import FlipMove from 'react-flip-move';
// import QuizAttemptCard from "./QuizAttemptCard";
import { sortBy } from "lodash";
import { disableSelection, enableSelection } from "../../util/DisableSelection";
import QuizAttemptCard from "../main/ClassSession/QuizAttemptCard";
import useWindowDimensions from "../../hooks/useWindowDimensions";
const LeaderboardView = ({ session_id }) => {
    const { class_session = null, teacher_details } = useSelector(({ dashboard }) => dashboard);
    const [processedSession, setProcessedSession] = useState({})
    const [] = useState(false)
    const [] = useState(null)
    let processed_session = {}
    const { height } = useWindowDimensions();
    /**
     * combines the session information for display
     */
    const processSession = () => {
        if (!class_session) {
            setProcessedSession({})
            return
        }
        const { question_details = [], students = [] } = class_session;
        const class_total_count = students.length;
        question_details.forEach(question => {
            question['attemptedCount'] = question.correct_attempts.length + question.incorrect_attempts.length
        })
        let attemptedSet = new Set()
        question_details.forEach(question => [...question.correct_attempts].concat(...question.incorrect_attempts).forEach(s => { attemptedSet.add(s) }))
        // total student count for table
        question_details.forEach(q => { q['total_count'] = class_total_count })
        console.log(attemptedSet)
        const class_attempted_count = attemptedSet.size
        processed_session = {
            class_total_count, class_attempted_count, question_details, students
        }
        //  add attempts data to student for tables
        let student_attempt_data = {}
        const update_attempt_count = (student_id, status) => {
            if (!student_attempt_data[student_id]) {
                student_attempt_data[student_id] = { "total": 0, "correct": 0 }
            }
            student_attempt_data[student_id]["total"] = student_attempt_data[student_id]["total"] + 1
            if (student_attempt_data[student_id]) {
                if (status)
                    student_attempt_data[student_id]["correct"] = student_attempt_data[student_id]["correct"] + 1
            }
        }
        question_details.forEach(question => {
            question.correct_attempts.forEach(student_id => {
                update_attempt_count(student_id, true)
            });
            question.incorrect_attempts.forEach(student_id => {
                update_attempt_count(student_id, false)
            });
        })
        students.forEach(s => { s['attempts'] = student_attempt_data[s.id] })
        setProcessedSession({ ...processed_session, students: sortBy(students, "points").reverse() })
    }
    const dispatch = useDispatch()

    useEffect(() => {
        disableSelection()
        return enableSelection
    }, [])
    useEffect(() => {
        dispatch(getClassAssignmentSession(session_id))
    }, session_id)

    useEffect(() => {
        if (class_session) {
            processSession()
            const { status } = class_session || {};
            setTimeout(() => {
                if (status !== 'completed') {
                    dispatch(getClassAssignmentSession(session_id))
                }
            }, 5000);
        }
    }, [class_session])


    return (
        <Auxiliary>
            {class_session && <Auxiliary>
                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Card>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }}> Assigned By: </span>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }}>{class_session.assigned_by}</span>
                                    </div>
                                </Col>
                                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }} > Date: </span>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }} >{getFormattedFromStamp(parseInt(class_session.start_date))}</span>
                                    </div>
                                </Col>
                                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }}> Chapter: </span>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }}>{class_session.chapter_name}</span>
                                    </div>
                                </Col>
                                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_title }}> Completed By: </span>
                                        <span className="gx-mr-1 gx-mb-1" style={{ ...styles.info_lable }}>{`${processedSession.class_attempted_count}/${processedSession.class_total_count}`}</span>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        {processedSession && processedSession.students && <div style={{ maxHeight: height - 150 }}><FlipMove>
                            {processedSession.students.map(student => {
                                return (<QuizAttemptCard showLinks={false} key={student.id} details={student} />)
                            })}

                        </FlipMove></div>}
                    </Col>
                </Row>
            </Auxiliary>
            }
        </Auxiliary>
    );
};
const styles = {
    info_lable: {
        whiteSpace: "nowrap",
        fontSize: "12px",

    },
    info_title: {
        whiteSpace: "nowrap",
        fontSize: "12px",
        fontWeight: 400
    }
}
export default LeaderboardView;